<script setup lang="ts">
import { useWindowSize } from "@vueuse/core";

const { width } = useWindowSize();
const appConfig = useAppConfig();
const accountStore = useAccountStore();
const { isMenuOpen } = storeToRefs(accountStore);

appConfig.ui.primary = "default";

const header = ref<ComponentPublicInstance | null>(null);

const calcHeaderHeight = computed(() => {
  if (width.value && header.value) {
    return header.value.$el.offsetHeight;
  }
  return 0;
});
</script>

<template>
  <div class="flex flex-col h-screen bg-white">
    <AccountNavbar ref="header" />
    <div
      class="flex flex-1 min-h-0 lg:!pt-0"
      :style="{ paddingTop: calcHeaderHeight + 'px' }"
    >
      <div
        class="flex-1 flex flex-col items-center justify-center p-4 lg:p-8 overflow-y-auto"
      >
        <div class="w-full flex flex-col">
          <slot />
        </div>
      </div>
      <div
        class="flex-1 hidden lg:block relative"
        :class="{
          'opacity-0 invisible pointer-events-none': isMenuOpen && width < 1024,
        }"
      >
        <div class="absolute inset-0">
          <img
            src="/log-in.jpeg"
            alt=""
            aria-hidden="true"
            class="w-full h-full object-cover object-center animate-blurFade"
          >
        </div>
      </div>
    </div>
  </div>
</template>
